import { ICamProductOptionsData } from './shared';

export const blutenProducts: ICamProductOptionsData[] = [
    {
        "label": "10/10 Vayamed CAN Cannabis Flos Substanz",
        "thc_cbd": "10/10",
        "partner": "Vayamed",
        "category": "THC/CBD"
    },
    {
        "label": "101-C Blüten Sativa LSAGE 22/1",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "22/1 Vayamed CAN Cannabis flos Substanz",
        "thc_cbd": "22/1",
        "partner": "Vayamed",
        "category": "THC"
    },
    {
        "label": "23/1 N!CE C",
        "thc_cbd": "23/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "25/1 Amici CP",
        "thc_cbd": "25/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "27/1 Amici AS",
        "thc_cbd": "27/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "27/1 Amici CP",
        "thc_cbd": "27/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "27/1 Amici WC",
        "thc_cbd": "27/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "29/1 Amici SB",
        "thc_cbd": "29/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "420 Evolution 20/1 CA PLD",
        "thc_cbd": "20/1",
        "partner": "Four 20 Pharma",
        "category": "THC"
    },
    {
        "label": "420 Evolution 22/1 CA MAC",
        "thc_cbd": "22/1",
        "partner": "Four 20 Pharma",
        "category": "THC"
    },
    {
        "label": "420 Evolution 25/1 CA ICC",
        "thc_cbd": "25/1",
        "partner": "Four 20 Pharma",
        "category": "THC+"
    },
    {
        "label": "420 Evolution 25/1 CA MAC",
        "thc_cbd": "25/1",
        "partner": "Four 20 Pharma",
        "category": "THC+"
    },
    {
        "label": "420 Evolution 27/1 CA FLM",
        "thc_cbd": "27/1",
        "partner": "Four 20 Pharma",
        "category": "THC+"
    },
    {
        "label": "420 Evolution 27/1 CA GMO",
        "thc_cbd": "27/1",
        "partner": "Four 20 Pharma",
        "category": "THC+"
    },
    {
        "label": "420 Evolution 27/1 CA ICC",
        "thc_cbd": "27/1",
        "partner": "Four 20 Pharma",
        "category": "THC+"
    },
    {
        "label": "420 Evolution 27/1 CA STR",
        "thc_cbd": "27/1",
        "partner": "Four 20 Pharma",
        "category": "THC+"
    },
    {
        "label": "420 Evolution 27/1 CA WES",
        "thc_cbd": "27/1",
        "partner": "Four 20 Pharma",
        "category": "THC+"
    },
    {
        "label": "420 Evolution 27/1 FLM",
        "thc_cbd": "27/1",
        "partner": "Four 20 Pharma",
        "category": "THC+"
    },
    {
        "label": "420 Evolution 30/1 CA BUL",
        "thc_cbd": "30/1",
        "partner": "Four 20 Pharma",
        "category": "THC+"
    },
    {
        "label": "420 Evolution 30/1 CA GMO",
        "thc_cbd": "30/1",
        "partner": "Four 20 Pharma",
        "category": "THC+"
    },
    {
        "label": "420 Evolution 30/1 CA ICC",
        "thc_cbd": "30/1",
        "partner": "Four 20 Pharma",
        "category": "THC+"
    },
    {
        "label": "420 Evolution 30/1 CA PCH",
        "thc_cbd": "30/1",
        "partner": "Four 20 Pharma",
        "category": "THC+"
    },
    {
        "label": "420 Evolution 30/1 CA WES",
        "thc_cbd": "30/1",
        "partner": "Four 20 Pharma",
        "category": "THC+"
    },
    {
        "label": "420 Natural 19/1 CA TRP",
        "thc_cbd": "19/1",
        "partner": "Four 20 Pharma",
        "category": "THC-"
    },
    {
        "label": "420 Natural 20/1 CA DBB",
        "thc_cbd": "20/1",
        "partner": "Four 20 Pharma",
        "category": "THC"
    },
    {
        "label": "420 Natural 20/1 CA GG4",
        "thc_cbd": "20/1",
        "partner": "Four 20 Pharma",
        "category": "THC"
    },
    {
        "label": "420 Natural 22/1 CA DBB",
        "thc_cbd": "22/1",
        "partner": "Four 20 Pharma",
        "category": "THC"
    },
    {
        "label": "420 Natural 22/1 CA GG4",
        "thc_cbd": "22/1",
        "partner": "Four 20 Pharma",
        "category": "THC"
    },
    {
        "label": "420 Natural 22/1 CA GG4",
        "thc_cbd": "22/1",
        "partner": "Four 20 Pharma",
        "category": "THC"
    },
    {
        "label": "420 Natural 25/1 CA GG4",
        "thc_cbd": "25/1",
        "partner": "Four 20 Pharma",
        "category": "THC+"
    },
    {
        "label": "420 Natural 27/1 CA ZRP",
        "thc_cbd": "27/1",
        "partner": "Four 20 Pharma",
        "category": "THC+"
    },
    {
        "label": "Adrex 17/1 CAN",
        "thc_cbd": "17/1",
        "partner": null,
        "category": "THC-"
    },
    {
        "label": "Adrex 21/1 LMOG COL",
        "thc_cbd": "21/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Adrex 26/1 AK COL",
        "thc_cbd": "26/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Adrex 30/1 8BK CAN",
        "thc_cbd": "30/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "ALL Nations GM-104",
        "thc_cbd": "28/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "ALL Nations SH-001",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Alpinolin 22/1",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Althea THC24",
        "thc_cbd": "23/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "amber 26/1",
        "thc_cbd": "26/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "AMP classic 18/1 Primary",
        "thc_cbd": "18/1",
        "partner": null,
        "category": "THC-"
    },
    {
        "label": "AMP classic 25/1",
        "thc_cbd": "25/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Aurora 1/12",
        "thc_cbd": "1/12",
        "partner": "Aurora",
        "category": "CBD"
    },
    {
        "label": "Aurora 1/16 VSP-CA",
        "thc_cbd": "1/16",
        "partner": "Aurora",
        "category": "CBD"
    },
    {
        "label": "Aurora 20/1",
        "thc_cbd": "20/1",
        "partner": "Aurora",
        "category": "THC"
    },
    {
        "label": "Aurora 22/1",
        "thc_cbd": "22/1",
        "partner": "Aurora",
        "category": "THC"
    },
    {
        "label": "Aurora 24/1 PNK-CA",
        "thc_cbd": "24/1",
        "partner": "Aurora",
        "category": "THC"
    },
    {
        "label": "Aurora Typ 1",
        "thc_cbd": "20/1",
        "partner": "Aurora",
        "category": "THC"
    },
    {
        "label": "AVAAY 12/8 Cannatonic Cannabis Hybrid Balanced Sub",
        "thc_cbd": "12/8",
        "partner": "Vayamed",
        "category": "THC/CBD"
    },
    {
        "label": "AVAAY 16/1 BBH Blueberry Haze Canna Sativa dom.",
        "thc_cbd": "16/1",
        "partner": "Vayamed",
        "category": "THC-"
    },
    {
        "label": "AVAAY 18/1 BBH Blueberry Haze Canna Sativa dom.",
        "thc_cbd": "18/1",
        "partner": "Vayamed",
        "category": "THC-"
    },
    {
        "label": "AVAAY 20/1 CK Critical Kush Canna Indica dom.Sub.",
        "thc_cbd": "20/1",
        "partner": "Vayamed",
        "category": "THC"
    },
    {
        "label": "AVAAY 20/1 Royal Gorilla Canna Sativa dom.Substanz",
        "thc_cbd": "20/1",
        "partner": "Vayamed",
        "category": "THC"
    },
    {
        "label": "AVAAY 20/1 SIMPLE TNG Tangie Cannabisbl.Sativa Sub",
        "thc_cbd": "20/1",
        "partner": "Vayamed",
        "category": "THC"
    },
    {
        "label": "AVAAY 21/1 BKR Black Krush Canna Indica Substanz",
        "thc_cbd": "21/1",
        "partner": "Vayamed",
        "category": "THC"
    },
    {
        "label": "AVAAY 21/1 SK Sour OG Kush Cannabisblü.Indica dom.",
        "thc_cbd": "21/1",
        "partner": "Vayamed",
        "category": "THC"
    },
    {
        "label": "AVAAY 22/1 BBH Blueberry Haze Canna Sativa dom.",
        "thc_cbd": "22/1",
        "partner": "Vayamed",
        "category": "THC"
    },
    {
        "label": "AVAAY 22/1 BCP Black Cherry Punch Canna Sativa dom",
        "thc_cbd": "22/1",
        "partner": "Vayamed",
        "category": "THC"
    },
    {
        "label": "AVAAY 22/1 LSB Lemon Sherbet Can.Hyb.Sativa dom.",
        "thc_cbd": "22/1",
        "partner": "Vayamed",
        "category": "THC"
    },
    {
        "label": "AVAAY 23/1 BKR Black Krush Canna Indica Substanz",
        "thc_cbd": "23/1",
        "partner": "Vayamed",
        "category": "THC"
    },
    {
        "label": "AVAAY 23/1 CK Critical Kush Canna Indica dom.Subst",
        "thc_cbd": "23/1",
        "partner": "Vayamed",
        "category": "THC"
    },
    {
        "label": "AVAAY 23/1 CRE Creamy Kees Canna Indica dom.Subst.",
        "thc_cbd": "23/1",
        "partner": "Vayamed",
        "category": "THC"
    },
    {
        "label": "AVAAY 23/1 PYC Peyote Critical Cannabisbl.Indi.Sub",
        "thc_cbd": "23/1",
        "partner": "Vayamed",
        "category": "THC"
    },
    {
        "label": "AVAAY 23/1 RG Royal Gorilla Canna Sativa dom.Subst",
        "thc_cbd": "23/1",
        "partner": "Vayamed",
        "category": "THC"
    },
    {
        "label": "AVAAY 24/1 BBH Blueberry Haze Canna Sativa dom.",
        "thc_cbd": "24/1",
        "partner": "Vayamed",
        "category": "THC"
    },
    {
        "label": "AVAAY 24/1 BCP Black Cherry Punch Canna Sativa dom",
        "thc_cbd": "24/1",
        "partner": "Vayamed",
        "category": "THC"
    },
    {
        "label": "AVAAY 24/1 DiD Do Si Dos Canna Indica dom.Substanz",
        "thc_cbd": "24/1",
        "partner": "Vayamed",
        "category": "THC"
    },
    {
        "label": "AVAAY 24/1 SK Sour OG Kush Canna Indica dom.Subst.",
        "thc_cbd": "24/1",
        "partner": "Vayamed",
        "category": "THC"
    },
    {
        "label": "AVAAY 25/1 CK Critical Kush Canna Indica dom.Subst",
        "thc_cbd": "25/1",
        "partner": "Vayamed",
        "category": "THC+"
    },
    {
        "label": "AVAAY 26/1 BBH Blueberry Haze Canna Sativa dom.",
        "thc_cbd": "26/1",
        "partner": "Vayamed",
        "category": "THC+"
    },
    {
        "label": "AVAAY 26/1 BCP Black Cherry Punch Canna Sativa dom",
        "thc_cbd": "26/1",
        "partner": "Vayamed",
        "category": "THC+"
    },
    {
        "label": "AVAAY 26/1 KH Karels Haze Canna Sativa Substanz",
        "thc_cbd": "26/1",
        "partner": "Vayamed",
        "category": "THC+"
    },
    {
        "label": "AVAAY 26/1 SK Sour OG Kush Canna Indica dom.Subst.",
        "thc_cbd": "26/1",
        "partner": "Vayamed",
        "category": "THC+"
    },
    {
        "label": "AVAAY 28/1 KH Karels Haze Canna Sativa Substanz",
        "thc_cbd": "28/1",
        "partner": "Vayamed",
        "category": "THC+"
    },
    {
        "label": "AVAAY SIGNATURE 23/1 CR Crescendo Canna Sativa dom",
        "thc_cbd": "23/1",
        "partner": "Vayamed",
        "category": "THC"
    },
    {
        "label": "AVAAY SIGNATURE 23/1 MC Mandarin Cookies Sativa do",
        "thc_cbd": "23/1",
        "partner": "Vayamed",
        "category": "THC"
    },
    {
        "label": "AVAAY SIGNATURE 25/1 PG Platinum Garlic Indica dom",
        "thc_cbd": "25/1",
        "partner": "Vayamed",
        "category": "THC+"
    },
    {
        "label": "AVAAY SIGNATURE 26/1 CR Crescendo Canna Sativa dom",
        "thc_cbd": "26/1",
        "partner": "Vayamed",
        "category": "THC+"
    },
    {
        "label": "AVAAY SIGNATURE 28/1 Platinum Garlic Can.Hyb.Ind.",
        "thc_cbd": "28/1",
        "partner": "Vayamed",
        "category": "THC+"
    },
    {
        "label": "AVAAY SIGNATURE 28/1 WB Waffle Bites Indica dom.",
        "thc_cbd": "28/1",
        "partner": "Vayamed",
        "category": "THC+"
    },
    {
        "label": "AVAAY SIGNATURE 30/1 CBX Chatterbox Can.Indica dom",
        "thc_cbd": "30/1",
        "partner": "Vayamed",
        "category": "THC+"
    },
    {
        "label": "AVAAY SIMPLE 21/1 CHM Chem OG Cannabisblüten Hybr",
        "thc_cbd": "21/1",
        "partner": "Vayamed",
        "category": "THC"
    },
    {
        "label": "AVAAY SIMPLE 23/1 LSB Lemon Sherbet Can.Hyb.Sat.d.",
        "thc_cbd": "23/1",
        "partner": "Vayamed",
        "category": "THC"
    },
    {
        "label": "BATHERA 25/1",
        "thc_cbd": "25/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Beacon I-Hybrid THC 22",
        "thc_cbd": "21/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Bedica",
        "thc_cbd": "16/1",
        "partner": null,
        "category": "THC-"
    },
    {
        "label": "Bediol",
        "thc_cbd": "7/9",
        "partner": null,
        "category": "THC/CBD"
    },
    {
        "label": "Bedrocan",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "BG GOG",
        "thc_cbd": "24/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "BG MI",
        "thc_cbd": "26/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Blackbird Strong Sativa",
        "thc_cbd": "21/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "C&C Cannabis 23/1",
        "thc_cbd": "23/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Canify 18/1 PT Mango",
        "thc_cbd": "18/1",
        "partner": null,
        "category": "THC-"
    },
    {
        "label": "Canify 20/1 UY Gorilla Glue",
        "thc_cbd": "20/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Canify 20/1 UY Purple Dog Bud",
        "thc_cbd": "20/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Canify 22/1 PT Headband",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Canify 22/1 PT Mango",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Canify 22/1 PT Pink Kush",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Canify 22/1 PT Sirius",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "CANNABIS 1A 18/1 flos Vayamed Substanz",
        "thc_cbd": "18/1",
        "partner": "Vayamed",
        "category": "THC-"
    },
    {
        "label": "CANNABIS BEDROCAN flos Substanz Vayamed",
        "thc_cbd": "22/1",
        "partner": "Vayamed",
        "category": "THC"
    },
    {
        "label": "Cannabis Flos 20/1 CO Ku.MAC",
        "thc_cbd": "20/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Cannabis Flos 22/1 PT Ku.ISS DAB Canify",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Cannabis Flos 22/1 PT Ku.Master Kush DAB Canify",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Cannabis Flos 23/1 CO Ku. Kush Mints Canify, Kush Minds",
        "thc_cbd": "23/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "CannabiStada® 22/1 GG",
        "thc_cbd": "22/1",
        "partner": "STADAPHARM",
        "category": "THC"
    },
    {
        "label": "CannabiStada® GAB 30",
        "thc_cbd": "30/1",
        "partner": "STADAPHARM",
        "category": "THC+"
    },
    {
        "label": "CannabiStada® VED 27",
        "thc_cbd": "27/1",
        "partner": "STADAPHARM",
        "category": "THC+"
    },
    {
        "label": "CannabiStada® 22/1 GG",
        "thc_cbd": "22/1",
        "partner": "STADAPHARM",
        "category": "THC"
    },
    {
        "label": "CannabiStada® GAB 30",
        "thc_cbd": "30/1",
        "partner": "STADAPHARM",
        "category": "THC+"
    },
    {
        "label": "CannabiStada® VED 27",
        "thc_cbd": "27/1",
        "partner": "STADAPHARM",
        "category": "THC+"
    },
    {
        "label": "Cannamedical Balanced classic",
        "thc_cbd": "6/10",
        "partner": null,
        "category": "THC/CBD"
    },
    {
        "label": "Cannamedical Balanced forte",
        "thc_cbd": "8/13",
        "partner": null,
        "category": "THC/CBD"
    },
    {
        "label": "Cannamedical Hybrid classic",
        "thc_cbd": "20/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Cannamedical Hybrid classic NG",
        "thc_cbd": "21/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Cannamedical Hybrid classic NM",
        "thc_cbd": "21/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Cannamedical Hybrid classic URY",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Cannamedical Hybrid forte",
        "thc_cbd": "23/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Cannamedical Hybrid forte DK",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Cannamedical Hybrid forte NG",
        "thc_cbd": "23/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Cannamedical Hybrid forte NM",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Cannamedical Hybrid forte PH",
        "thc_cbd": "25/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Cannamedical Hybrid light NM",
        "thc_cbd": "17/1",
        "partner": null,
        "category": "THC-"
    },
    {
        "label": "Cannamedical Hybrid ultra NG",
        "thc_cbd": "27/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Cannamedical Indica classic",
        "thc_cbd": "19/1",
        "partner": null,
        "category": "THC-"
    },
    {
        "label": "Cannamedical Indica classic NM",
        "thc_cbd": "21/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Cannamedical Indica classic URY",
        "thc_cbd": "21/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Cannamedical Indica classic ZAF",
        "thc_cbd": "20/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Cannamedical Indica forte",
        "thc_cbd": "26/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Cannamedical Indica forte M",
        "thc_cbd": "25/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Cannamedical Indica forte MA",
        "thc_cbd": "24/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Cannamedical Indica forte NM",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Cannamedical Indica light NM",
        "thc_cbd": "18/1",
        "partner": null,
        "category": "THC-"
    },
    {
        "label": "Cannamedical Indica ultra",
        "thc_cbd": "28/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Cannamedical Indica ultra AU",
        "thc_cbd": "27/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Cannamedical Indica ultra SF",
        "thc_cbd": "27/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Cannamedical Sativa classic",
        "thc_cbd": "21/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Cannamedical Sativa classic AU",
        "thc_cbd": "21/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Cannamedical Sativa classic NM",
        "thc_cbd": "21/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Cannamedical Sativa forte",
        "thc_cbd": "24/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Cannamedical Sativa forte MA",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Cannamedical Sativa forte NM",
        "thc_cbd": "25/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Cannamedical Sativa light",
        "thc_cbd": "17/1",
        "partner": null,
        "category": "THC-"
    },
    {
        "label": "Cannamedical Sativa vita",
        "thc_cbd": "14/1",
        "partner": null,
        "category": "THC-"
    },
    {
        "label": "Cannamedical Sunshine Coast",
        "thc_cbd": "1/14",
        "partner": null,
        "category": "CBD"
    },
    {
        "label": "Cannovum 20/1 Luna",
        "thc_cbd": "20/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Cannovum Natura 25/1 Vivid",
        "thc_cbd": "25/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Canopy AKH 22",
        "thc_cbd": "24/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Canopy Bakerstreet 20",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Canopy GDB 12",
        "thc_cbd": "1/13",
        "partner": null,
        "category": "CBD"
    },
    {
        "label": "Canopy HSK 8/7",
        "thc_cbd": "8/7",
        "partner": null,
        "category": "THC/CBD"
    },
    {
        "label": "Canopy KMI 28",
        "thc_cbd": "27/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Canopy Krypton 25",
        "thc_cbd": "24/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Canopy LSK 16",
        "thc_cbd": "17/1",
        "partner": null,
        "category": "THC-"
    },
    {
        "label": "Canopy OGD 25",
        "thc_cbd": "26/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Canopy TCK 27",
        "thc_cbd": "28/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Ceres No.2",
        "thc_cbd": "25/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "CM 16/1 GRP",
        "thc_cbd": "16/1",
        "partner": null,
        "category": "THC-"
    },
    {
        "label": "CM 20/1 GG4",
        "thc_cbd": "20/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "CM 20/1 LLY",
        "thc_cbd": "20/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "CM 24/1 LLY",
        "thc_cbd": "24/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "CM 24/1 SUN",
        "thc_cbd": "24/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "CM 24/1 ZA",
        "thc_cbd": "24/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "CM 27/1 PO",
        "thc_cbd": "27/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "CM 27/1 Punch",
        "thc_cbd": "27/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "CM28/1 ZA",
        "thc_cbd": "28/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "CNBS FFC 21/1",
        "thc_cbd": "21/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "CNBS GELO 20/1",
        "thc_cbd": "20/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Costa Canna Dynamics-forte",
        "thc_cbd": "25/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Costa Canna Dynamics-fortissimo",
        "thc_cbd": "29/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "CRAFT Black Triangle 27:01",
        "thc_cbd": "27/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Craft FCF 31:01",
        "thc_cbd": "30/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Craft GNC 24:01",
        "thc_cbd": "26/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Craft T4N-G",
        "thc_cbd": "25/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "CRAFT Titanimal 23:01",
        "thc_cbd": "24/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "CRAFT Tricolo 27:01",
        "thc_cbd": "28/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "CRAFT WALKIE TALKIE 31:01",
        "thc_cbd": "31/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Craft zoerO 25:01",
        "thc_cbd": "24/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Demecan 22:01 Florestura",
        "thc_cbd": "23/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Demecan 25:01 GOG-K",
        "thc_cbd": "24/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Demecan MC Epic Drop",
        "thc_cbd": "29/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Drapalin 1/17 Maluti CBD",
        "thc_cbd": "1/17",
        "partner": null,
        "category": "CBD"
    },
    {
        "label": "Drapalin 10/11 Batha Balance",
        "thc_cbd": "10/11",
        "partner": null,
        "category": "THC/CBD"
    },
    {
        "label": "Drapalin 18/1 Cheesotho",
        "thc_cbd": "18/1",
        "partner": null,
        "category": "THC-"
    },
    {
        "label": "Drapalin 24/1 Bafokeng Choice",
        "thc_cbd": "24/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "enua 22/1 CRO CA",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "enua 22/1 JFG",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "enua 22/1 JFG CA",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "enua 22/1 JLSY CA",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "enua 22/1 MAC F CA",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "enua 25/1 CCK CA",
        "thc_cbd": "25/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "enua 25/1 CRO CA",
        "thc_cbd": "25/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "enua 25/1 QSG CA",
        "thc_cbd": "25/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "enua 25/1 SC CA",
        "thc_cbd": "25/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "enua 25/1 SLC CA",
        "thc_cbd": "25/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "enua 27/1 CCK CA",
        "thc_cbd": "27/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "enua 27/1 DSH CA",
        "thc_cbd": "27/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "enua 30/1 CCK CA",
        "thc_cbd": "30/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "enua organic 25/1 CRO CA",
        "thc_cbd": "25/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "enua organic 25/1 QSG CA",
        "thc_cbd": "25/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Epic Drop",
        "thc_cbd": "31/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "GM Colour of Space 26:01",
        "thc_cbd": "26/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "GM Colour of Space 28:01",
        "thc_cbd": "29/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "GM Supernova 25:01",
        "thc_cbd": "24/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Green Karat CG",
        "thc_cbd": "29/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Green Karat MG",
        "thc_cbd": "26/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Green Karat PV",
        "thc_cbd": "29/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Green Karat RO",
        "thc_cbd": "30/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Grow 18 HF Mac",
        "thc_cbd": "19/1",
        "partner": null,
        "category": "THC-"
    },
    {
        "label": "Grow 20 EU",
        "thc_cbd": "20/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Herbasana Colombiana 20:01 AS",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "IBT03.4",
        "thc_cbd": "19/1",
        "partner": null,
        "category": "THC-"
    },
    {
        "label": "IMC 17/1",
        "thc_cbd": "17/1",
        "partner": null,
        "category": "THC-"
    },
    {
        "label": "IMC 20/1",
        "thc_cbd": "20/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "IMC CBD12 C01",
        "thc_cbd": "1/13",
        "partner": null,
        "category": "CBD"
    },
    {
        "label": "IMC CBD14 C01",
        "thc_cbd": "1/13",
        "partner": null,
        "category": "CBD"
    },
    {
        "label": "IMC GGA THC22",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "IMC PBM THC27",
        "thc_cbd": "27/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "IMC THC 17 T01",
        "thc_cbd": "19/1",
        "partner": null,
        "category": "THC-"
    },
    {
        "label": "IMC THC 20",
        "thc_cbd": "21/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "IMC THC20 T01",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "IMC THC22 T01",
        "thc_cbd": "23/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "IMC THC22 T02",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "IMC THC25 T04",
        "thc_cbd": "27/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Indica forte MA",
        "thc_cbd": "23/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "KEjF.SKR 23/1",
        "thc_cbd": "23/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "KEjF.SMNZ 25/1",
        "thc_cbd": "25/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "KEjF.WRM 21/1",
        "thc_cbd": "21/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Khiron G 19/1",
        "thc_cbd": "19/1",
        "partner": null,
        "category": "THC-"
    },
    {
        "label": "LOT 420 AB",
        "thc_cbd": "27/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "LOT 420 ATA",
        "thc_cbd": "26/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "LOT 420 GLT",
        "thc_cbd": "26/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "LOT 420 OC",
        "thc_cbd": "28/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "MAC 1+",
        "thc_cbd": "24/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Madrecan 21/1 MAC",
        "thc_cbd": "21/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Madrecan 21/1 MDR",
        "thc_cbd": "21/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Madrecan 21/1 RCH",
        "thc_cbd": "21/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Madrecan 21/1 SHA",
        "thc_cbd": "21/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Madrecan 21/1 WOP",
        "thc_cbd": "21/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "MC Regular Drop",
        "thc_cbd": "25/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "MC Strong Drop",
        "thc_cbd": "25/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "MCCN No.5",
        "thc_cbd": "21/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Mediprocan Smaragd 22/1",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "MedMen Black Cherry Punch T25",
        "thc_cbd": "25/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "MyCanna 16/1",
        "thc_cbd": "16/1",
        "partner": null,
        "category": "THC-"
    },
    {
        "label": "Navcora Spotlight Porto",
        "thc_cbd": "23/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Navcora THC22 Spotlight Porto",
        "thc_cbd": "23/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Nimbus EASY 22/1",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Nimbus GNC 24/1",
        "thc_cbd": "24/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Nimbus RZM 22/1",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Nimbus ZRP 21/1",
        "thc_cbd": "21/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Nimbus ZRP 26/1",
        "thc_cbd": "26/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Oceanic BC",
        "thc_cbd": "24/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Organic MC 25:01",
        "thc_cbd": "23/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Origine Nature COG",
        "thc_cbd": "26/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Ostara Eclipse",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Ostara Solar",
        "thc_cbd": "25/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Peace Naturals 27/1 CB",
        "thc_cbd": "27/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Peace Naturals 31/1 GC",
        "thc_cbd": "31/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Peace Naturals 31/1 SC",
        "thc_cbd": "31/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Pedanios 10/10 EQI-CA",
        "thc_cbd": "10/10",
        "partner": "Aurora",
        "category": "THC/CBD"
    },
    {
        "label": "Pedanios 10/13 MNB-CA",
        "thc_cbd": "10/13",
        "partner": "Aurora",
        "category": "THC/CBD"
    },
    {
        "label": "Pedanios 18/1 TNG-CA",
        "thc_cbd": "18/1",
        "partner": "Aurora",
        "category": "THC-"
    },
    {
        "label": "Pedanios 20/1",
        "thc_cbd": "20/1",
        "partner": "Aurora",
        "category": "THC"
    },
    {
        "label": "Pedanios 22/1",
        "thc_cbd": "22/1",
        "partner": "Aurora",
        "category": "THC"
    },
    {
        "label": "Pedanios 24/1 LAC-CA",
        "thc_cbd": "24/1",
        "partner": "Aurora",
        "category": "THC"
    },
    {
        "label": "Pedanios 26/1 EHD-CA",
        "thc_cbd": "26/1",
        "partner": "Aurora",
        "category": "THC+"
    },
    {
        "label": "Pedanios 27/1 FRG-CA",
        "thc_cbd": "27/1",
        "partner": "Aurora",
        "category": "THC+"
    },
    {
        "label": "Pedanios 27/1 PND-CA",
        "thc_cbd": "27/1",
        "partner": "Aurora",
        "category": "THC+"
    },
    {
        "label": "Pedanios 28/1 CMK-CA",
        "thc_cbd": "28/1",
        "partner": "Aurora",
        "category": "THC+"
    },
    {
        "label": "Pedanios 29/1 SRD-CA",
        "thc_cbd": "29/1",
        "partner": "Aurora",
        "category": "THC+"
    },
    {
        "label": "Pedanios 8/8",
        "thc_cbd": "8/8",
        "partner": "Aurora",
        "category": "THC/CBD"
    },
    {
        "label": "Pure Sunfarms 20/1",
        "thc_cbd": "20/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "RE:CANNIS 16/1 Sativa",
        "thc_cbd": "16/1",
        "partner": null,
        "category": "THC-"
    },
    {
        "label": "RE:CANNIS 21/1 Indica",
        "thc_cbd": "21/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "RE:CANNIS 9.5/10.5 Hybrid",
        "thc_cbd": "10/11",
        "partner": null,
        "category": "THC/CBD"
    },
    {
        "label": "remexian 18/1",
        "thc_cbd": "18/1",
        "partner": null,
        "category": "THC-"
    },
    {
        "label": "remexian 20/1",
        "thc_cbd": "20/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "remexian 22/1",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "remexian 22/1 APX",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "remexian 22/1 HUW",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "remexian 23/1 MAD",
        "thc_cbd": "23/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "remexian 25/1",
        "thc_cbd": "25/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "remexian 25/1 GAC",
        "thc_cbd": "25/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "remexian 25/1 GG4",
        "thc_cbd": "25/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "remexian 25/1 LPP",
        "thc_cbd": "25/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "remexian 27/1 GRG",
        "thc_cbd": "27/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "remexian 30/1 GMO",
        "thc_cbd": "30/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "remexian 30/1 JUC",
        "thc_cbd": "30/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Sibanax Hybrid MCF 23/1",
        "thc_cbd": "23/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Sumo Canada craft No.2",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Sunshine Cresina 24:01",
        "thc_cbd": "23/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Supreme 18/1",
        "thc_cbd": "18/1",
        "partner": null,
        "category": "THC-"
    },
    {
        "label": "Supreme 24/1",
        "thc_cbd": "24/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Therismos 25/1 DSM",
        "thc_cbd": "25/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Therismos 27/1 JFG",
        "thc_cbd": "27/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Tilray Cannabisblüten THC15 Spotlight Porto",
        "thc_cbd": "15/1",
        "partner": "Tilray",
        "category": "THC-"
    },
    {
        "label": "Tilray Cannabisblüten THC18 Spotlight Porto",
        "thc_cbd": "18/1",
        "partner": "Tilray",
        "category": "THC-"
    },
    {
        "label": "Tilray Cannabisblüten THC22 Indica No.2",
        "thc_cbd": "22/1",
        "partner": "Tilray",
        "category": "THC"
    },
    {
        "label": "Tilray Cannabisblüten THC22 Sativa No.2",
        "thc_cbd": "22/1",
        "partner": "Tilray",
        "category": "THC"
    },
    {
        "label": "Tilray Cannabisblüten THC22 Spotlight Porto",
        "thc_cbd": "22/1",
        "partner": "Tilray",
        "category": "THC"
    },
    {
        "label": "Tilray Cannabisblüten THC25 Indica No.2",
        "thc_cbd": "25/1",
        "partner": "Tilray",
        "category": "THC+"
    },
    {
        "label": "Tilray Cannabisblüten THC25 Sativa No.2",
        "thc_cbd": "25/1",
        "partner": "Tilray",
        "category": "THC+"
    },
    {
        "label": "Tilray Cannabisblüten THC25 Spotlight Porto",
        "thc_cbd": "25/1",
        "partner": "Tilray",
        "category": "THC+"
    },
    {
        "label": "Tilray Cannabisblüten THC9:CBD9 No.2",
        "thc_cbd": "9/9",
        "partner": "Tilray",
        "category": "THC/CBD"
    },
    {
        "label": "Tilray Cannabisblüten THC10:CBD10 No.2",
        "thc_cbd": "10/10",
        "partner": "Tilray",
        "category": "THC/CBD"
    },
    {
        "label": "Typ 1 Demecan",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Typ 1 Demecan Forte",
        "thc_cbd": "22/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Typ 2 Demecan",
        "thc_cbd": "16/1",
        "partner": null,
        "category": "THC-"
    },
    {
        "label": "Vasco GG",
        "thc_cbd": "24/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Vasco WR",
        "thc_cbd": "23/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Weeco 23/1",
        "thc_cbd": "23/1",
        "partner": null,
        "category": "THC"
    },
    {
        "label": "Weeco 25/1",
        "thc_cbd": "25/1",
        "partner": null,
        "category": "THC+"
    },
    {
        "label": "Weeco Duke 24/1",
        "thc_cbd": "24/1",
        "partner": null,
        "category": "THC"
    }
]
